import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-paused-syndicate-popup",
    templateUrl: "./paused-syndicate-popup.component.html",
    styleUrls: ["./paused-syndicate-popup.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class PausedSyndicateComponent {
  constructor(
    private matDialogRef: MatDialogRef<PausedSyndicateComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {}

  close() {
    this.matDialogRef.close({ leaveClicked: false, syndicateData: null });
  }

  public confirmLeaveReason() {
    this.matDialogRef.close({ leaveClicked: true, syndicateData: this.data });
  }
}
